export default __webpack_public_path__ + "static/media/master-class-1.f6760e66.jpeg";